import React from 'react';
import {Modal, ModalBody} from 'reactstrap';
import styles from './styles.module.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {IOrderItem} from "../../ts/interfaces/Order/interface";


interface ModalConfirmProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    setSelectedProducts: (value: IOrderItem[] | null) => void;
    items: IOrderItem[];
}

const ProductsModal: React.FC<ModalConfirmProps> = ({
                                                        open,
                                                        setOpen,
                                                        setSelectedProducts,
                                                        items
                                                    }) => {
    const toggle = () => {
        setSelectedProducts(null);
        setOpen(false);
    }

    return (
        <Modal isOpen={open} size="xl" toggle={toggle} className={styles.modalContent}>
            <ModalBody className={styles.modalBody}>
                <span className={styles.close} onClick={() => setOpen(!open)}>&times;</span>
                <div className={styles.tableProducts}>
                    <table>
                        <thead>
                        <tr>
                            <th>Item</th>
                            <th>Tamanho</th>
                            <th>Quantidade</th>
                            <th>Preço</th>
                            <th>Total</th>
                        </tr>
                        </thead>
                        {items.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td className={styles.item}>
                                        <img
                                            src={item.image_url ?? ''}
                                            alt={item.name}/>
                                        <div>
                                            <p>{item.name}</p>
                                            <span>SKU: {item.sku}</span>
                                        </div>
                                    </td>
                                    <td>{item.size}</td>
                                    <td>{item.quantity}</td>
                                    <td>{item.price}</td>
                                    <td>{item.totalPrice}</td>
                                </tr>
                            )
                        })}
                    </table>

                </div>
            </ModalBody>
        </Modal>
    );
};

export default ProductsModal;
